import { useMyProductContracts } from "@/api/services/main/product-contract";
import { useMemo } from "react";

/**
 * 取り込みテンプレートの「プロダクトアクセス権限」に出す選択肢。
 * `/product-contracts` の `product.name` はマスタ（master_products.name、未連携時は products.name）解決済みで、
 * サーバー側の取り込み検証もこの名前との完全一致で判定する。表記をここで加工してはいけない。
 */
export const useImportProductOptions = (): string[] => {
  const { data: contracts } = useMyProductContracts();

  return useMemo(() => Array.from(new Set(contracts.map((contract) => contract.product.name).filter(Boolean))), [contracts]);
};
